import React from 'react'
import FaqBanner from '../components/Faq/FaqBanner'
import Footer from '../components/Footer'
import FaqAccordion from '../components/Faq/FaqAccordion'
import { Box } from '@mui/material'

export default function Faq() {
  return (
    <>
    <FaqBanner/>
    <Box className="pplacd-container">
    <FaqAccordion/>
    </Box> 
    <Footer/>
    </>
  )
}
